module.exports = __webpack_public_path__ + "static/media/made-with-bulma.e0eab74d.png";